import React, {PropTypes} from "react";

class PersonalInfo extends React.Component {

  constructor() {
    super();
  }

  render() {
    return (
      <div className="col-md-12">
        <table style={{marginBottom: 0, width: '100%'}} className="table table-bordered">
          <thead>
          <tr>
            <th cellPadding="0" colSpan="4">
              <span className="bold pull-left"> Personal Info</span>
              <span className="bold hrms-link pull-right"><a onClick={this.props.edit}><i className="icon-edit"></i> Edit</a></span>
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td style={{align: 'left', width: '18%'}}>Name :</td>
            <td style={{align: 'left', width: '28%'}}>
              <span id="ContentPlaceHolder1_txtName"
                    className="GenText">{this.props.employee.name ? this.props.employee.name : 'NA'}</span>
            </td>
            <td style={{align: 'left'}}>Gender :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblAnniversary"
                    className="GenText">{this.props.employee.gender ? this.props.employee.gender : 'NA'}</span>
            </td>
          </tr>
          <tr>
            <td style={{align: 'left'}}>Date of birth :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB"
                    className="GenText">{this.props.employee.empDOB ? new Date(this.props.employee.empDOB).toLocaleDateString('en-GB').substr(0, 10) : null}</span>
            </td>
            <td style={{align: 'left'}}>Email Id Personal:</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_txtSpouseName"
                    className="GenText">{this.props.employee.emailIdPersonal}</span>
            </td>

          </tr>


          <tr>
            <td style={{align: 'left'}}>Marital Status :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblDOB"
                    className="GenText">{this.props.employee.maritalStatus ? this.props.employee.maritalStatus : 'NA'}</span>
            </td>

            <td style={{align: 'left'}}>Anniversary :</td>
            <td style={{align: 'left'}}>
              <span id="ContentPlaceHolder1_lblAnniversary"
                    className="GenText">{this.props.employee.empAnniversary ? this.props.employee.empAnniversary : 'NA'}</span>
            </td>
          </tr>

          <tr>

          </tr>

          </tbody>
        </table>


      </div>
    );
  }
}

PersonalInfo.propTypes = {};

export default PersonalInfo;





/** WEBPACK FOOTER **
 ** ./src/components/joiningForm/Tables/PersonalInfo.js
 **/